import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Users, MapPin, Award, Star } from "lucide-react";

const SPECIALTIES = ["", "ICU", "ER", "Med-Surg", "OR", "Cath Lab", "Respiratory Therapy", "Physical Therapy", "Radiology"];

export default function ClinicianDirectory() {
  const [clinicians, setClinicians] = useState([]);
  const [specialty, setSpecialty] = useState("");

  const load = async () => {
    const params = specialty ? { specialty } : {};
    const { data } = await api.get("/clinicians", { params });
    setClinicians(data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [specialty]);

  return (
    <div className="space-y-6" data-testid="clinician-directory">
      <div>
        <div className="overline text-trital-red">Talent</div>
        <h1 className="mt-1 font-display font-black text-3xl lg:text-4xl text-slate-900 tracking-tight">Clinician Directory</h1>
      </div>
      <div className="flex items-center gap-3">
        <select value={specialty} onChange={(e) => setSpecialty(e.target.value)} className="px-3 py-2 rounded-lg border border-slate-300 text-sm">
          {SPECIALTIES.map((s) => <option key={s} value={s}>{s || "All specialties"}</option>)}
        </select>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {clinicians.map((c) => (
          <div key={c.id} className="rounded-2xl bg-white border border-slate-200 p-5 shadow-card hover:-translate-y-1 hover:shadow-card-hover transition-all">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-trital-navy text-white flex items-center justify-center font-display font-bold">{c.name?.[0]}</div>
              <div>
                <div className="font-display font-bold text-slate-900">{c.name}</div>
                <div className="text-xs text-slate-500 flex items-center gap-1"><MapPin className="w-3 h-3" /> {c.license_state || "—"}</div>
              </div>
            </div>
            <div className="mt-3 flex items-center gap-2 flex-wrap">
              <span className="text-[10px] px-2 py-0.5 rounded-full bg-trital-medical-blue-soft text-trital-navy font-bold uppercase tracking-wider">{c.specialty}</span>
              <span className="text-[10px] px-2 py-0.5 rounded-full bg-slate-100 text-slate-700 font-bold uppercase tracking-wider">{c.years_experience} yrs</span>
              {c.travel_ready && <span className="text-[10px] px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 font-bold uppercase tracking-wider">Travel-ready</span>}
            </div>
            <p className="mt-3 text-sm text-slate-600 line-clamp-2">{c.bio}</p>
            <div className="mt-3 flex items-center justify-between text-xs">
              <div className="flex items-center gap-1 text-trital-red"><Award className="w-3.5 h-3.5" /> {c.pay_expectation ? `$${c.pay_expectation}/hr` : "—"}</div>
              <button className="px-3 py-1.5 rounded-full bg-trital-navy text-white font-semibold text-xs btn-lift hover:bg-trital-navy-deep">View profile →</button>
            </div>
          </div>
        ))}
        {clinicians.length === 0 && <div className="text-slate-500 bg-white border border-slate-200 rounded-xl p-6 md:col-span-2 lg:col-span-3">No clinicians match.</div>}
      </div>
    </div>
  );
}
